import BasicLayout from '@/layouts/basic-layout'

const prefix = 'storage-manage-termination-agreement-archiving-'
export default [
  {
    path: '/storage-manage/termination-agreement-archiving',
    component: BasicLayout,
    children: [
      {
        path: 'detail-create',
        name: `${prefix}create`,
        auth: ['hidden'],
        meta: {title: '解约协议书归档新增'},
        component: () => import('@/pages/storage-manage/termination-agreement-archiving/detail-create')
      },
      {
        path: 'detail-edit/:id',
        name: `${prefix}edit`,
        auth: ['hidden'],
        meta: {cache: true, title: '解约协议书归档编辑'},
        component: () => import('@/pages/storage-manage/termination-agreement-archiving/detail-edit')
      },
      {
        path: 'detail-view/:id',
        name: `${prefix}view`,
        auth: ['hidden'],
        meta: {title: '解约协议书归档详情'},
        component: () => import('@/pages/storage-manage/termination-agreement-archiving/detail-view')
      }
    ]
  }
]
